import React from 'react';
import { 
  Box, 
  Typography, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { faqSectionStyles } from '../styles';

export const FAQ = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('ecommerce.support.faq.q1', '¿Cómo puedo ver mis facturas anteriores?'),
      answer: t('ecommerce.support.faq.a1', 'Puedes ver todas tus facturas anteriores desde tu panel de usuario, en la sección "Mis Facturas". También puedes solicitar copias llamando al (305) 821-4080.')
    },
    {
      question: t('ecommerce.support.faq.q2', '¿Cómo solicito una cotización?'),
      answer: t('ecommerce.support.faq.a2', 'Para solicitar una cotización, puedes usar el formulario de esta página, enviarnos un email a quote@sylroofingsupply.com, o llamarnos directamente. Nuestro equipo te responderá en menos de 24 horas.')
    },
    {
      question: t('ecommerce.support.faq.q3', '¿Cuál es el estado de mi entrega?'),
      answer: t('ecommerce.support.faq.a3', 'Puedes revisar el estado de tu entrega en tu panel de usuario o contactándonos directamente. Te mantendremos informado sobre cualquier actualización del estado de tu pedido.')
    },
    {
      question: t('ecommerce.support.faq.q4', '¿Qué tipos de productos ofrecen?'),
      answer: t('ecommerce.support.faq.a4', 'Ofrecemos una amplia gama de materiales para techado de alta calidad incluyendo tejas, materiales de impermeabilización, aislamiento, y accesorios. Consulta nuestro catálogo completo en la aplicación.')
    },
    {
      question: t('ecommerce.support.faq.q5', '¿Cuáles son sus horarios de atención?'),
      answer: t('ecommerce.support.faq.a5', 'Estamos disponibles de lunes a viernes de 8:00 AM a 5:00 PM EST. Para emergencias fuera de horario, puedes enviarnos un email y te responderemos al siguiente día hábil.')
    }
  ];

  return (
    <Box sx={faqSectionStyles.container}>
      <Typography variant="h2" sx={faqSectionStyles.title}>
        {t('ecommerce.support.faq.title', 'Preguntas Frecuentes')}
      </Typography>
      
      {faqs.map((faq, index) => (
        <Accordion 
          key={index} 
          sx={faqSectionStyles.accordion}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={faqSectionStyles.accordionSummary}
          >
            <Typography sx={faqSectionStyles.questionText}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={faqSectionStyles.answerText}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQ; 